import * as React from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import './LiveControls.css';
import * as Server from './Server.js';
import DisplayURLDialog from "./DisplayURLDialog.js"
import ImagineDialog from "./ImagineDialog.js"
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import LinkIcon from '@mui/icons-material/Link';
import Stack from '@mui/material/Stack';
import ClearIcon from '@mui/icons-material/Clear';
import {label} from './Dictionary.js';
import {theme_info} from './theme.js';
import Fab from '@mui/material/Fab';
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CircularProgress from '@mui/material/CircularProgress';
import LiveStatus from './LiveStatus.js';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

function Controls({set_battery_level_fn}) {

    const [isStatusKnown, setStatusKnown] = React.useState(false);
    const [isWakeDialogOpen, setWakeDialogOpen] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false); 
    const [dialogType, setDialogType] = React.useState(null);
    const [current_image_url, setCurrentImageURL] = React.useState("");
    const [isPortrait, setIsPortrait] = React.useState(true);
    const [wakeTimeRemaining, setWakeTimeRemaining] = React.useState(0);
    const searchParams = new URLSearchParams(document.location.search);

	const handleResize = () => {
        let elem = document.getElementById("FrameImage")
        if (!elem)
            return
        for (let i=0; i<4; i++) {
            if (elem.width > elem.height) {
                elem.border = elem.width/20;
                elem.style.padding = elem.width/10 + "px";
            } else {
                elem.border = elem.height/20;
                elem.style.padding = elem.height/10 + "px";
            }
        }
    };

    function ShowWakeInfoAsNeeded() {

        Server.GetDeviceDetails(searchParams.get("device_id"))
        .then((res) => {
            set_battery_level_fn(res.data.battery_level, res.data.status)
            if (res.data.has_connected) {
                setWakeTimeRemaining(Math.floor(res.data.wake_status.seconds_to_sleep / res.data.wake_status.wake_time_seconds * 100))
                setIsPortrait(res.data.config.orientation=="portrait")
                if (res.data.current_image_url != current_image_url) {
                    setCurrentImageURL(res.data.current_image_url);
                    setLoading(false)
                }
                if (res.data.status == "Active")
                    setWakeDialogOpen(false)
            } 
            setStatusKnown(true)
            
        })
    }

    React.useEffect(() => {

        ShowWakeInfoAsNeeded();
        const interval = setInterval(() => {
            ShowWakeInfoAsNeeded();
        }, 3000);

        return () => clearInterval(interval);

    });

    React.useEffect(() => {

        let elem = document.getElementById("FrameImage")
        if (elem) {
            elem.addEventListener('load', handleResize);
            if (current_image_url == "clear")
                elem.src = "clear_image.png";
            else
                elem.src = current_image_url;
            return () => elem.removeEventListener('resize', handleResize);
        }
    
    }, [current_image_url]);    

    const handleClose = () =>{
        setDialogType(null);
    };

    const handleSubmit = (text, template_id) => {

        setLoading(true);
        var device_id = searchParams.get("device_id")
        
        if (dialogType === "Imagine") {
            Server.AddImagine(device_id, text)
            .then((res) => {
                //setLoading(false);
            }).catch((err) => {
                alert(err.response.data.message)
                setLoading(false);
            })

        } else if (dialogType === "URL") {

            Server.AddRenderURL(device_id, text)
            .then((res) => {
                //setLoading(false);
            })

        }

    };


    const onButtonClicked = (mode) => {
        if (mode === "Clear") {

            if (current_image_url == "clear")
                return;

            setLoading(true);
            var device_id = searchParams.get("device_id")
            Server.AddClear(device_id, false)
            .then((res) => {
                //setLoading(false);
            })

        } else    
            setDialogType(mode);

    };

    const handleUpload = (event) => {
        //setDialogType(null);
        setLoading(true);
        handleMenuClose();

        Server.AddUpload(searchParams.get("device_id"), event.target.files[0])
        .then((response) => response.json())
        .then((result) => {
            console.log('Success:', result);
            //setLoading(false);
        })
        .catch((error) => {
            console.error('Error:', error);
            setLoading(false);
        });
	};

     React.useEffect(() => {
 		window.addEventListener('resize', handleResize);
  		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

     const divFramePortrait = {
        boxShadow: "inset 0px 0px 7px rgba(0,0,0,1)",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%) rotate(90deg)",
        maxWidth: "90%",
        maxHeight: "60%",
       }

     const divFrameLandscape = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translateX(-50%) translateY(-50%)",
        maxWidth: "90%",
        maxHeight: "70%",
     }

    const fabActiveStyle = {
        position: 'fixed',
        bottom: 100,
        right: 30,
        backgroundColor: theme_info("accent_color")
      };

      const fabProgress = {
        position: 'fixed',
        bottom: 103,
        right: 32,
        color: "rgb(255,255,255)"
      };

      const fabDisabledStyle = {
        position: 'fixed',
        bottom: 100,
        right: 30,
        backgroundColor: "rgb(50,50,50)"
      };

        const [anchorEl, setAnchorEl] = React.useState(null);
        const isMenuOpen = Boolean(anchorEl);
    
        const handleMenuClose = () => {
            setAnchorEl(null);
        };

        const handleActiveControls = (event) => {
            setAnchorEl(event.currentTarget);
        };

      function handleDisabledControls() {
        setWakeDialogOpen(true);
      }

    if (!isStatusKnown)
        return (<></>)
    else 
       return (
        <>
        <LiveStatus isLoading={isLoading} isNeedsWake={isWakeDialogOpen} onWakeDialogClick={()=>{setWakeDialogOpen(false)}}></LiveStatus>
          <>
            {wakeTimeRemaining>0 ? (
                <Fab sx={fabActiveStyle} color="primary" aria-label="add" onClick={handleActiveControls}>
                <CircularProgress value={wakeTimeRemaining} variant="determinate" size="51px" sx={fabProgress}/>
                <SettingsRemoteIcon />
                </Fab>
            ) : (
                <Fab sx={fabDisabledStyle} color="primary" aria-label="add" onClick={handleDisabledControls}>
                <SettingsRemoteIcon />
                </Fab>
            )}

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={handleMenuClose}
                MenuListProps={{
                'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem component="label" ><ListItemIcon><CloudUploadIcon /></ListItemIcon><ListItemText>{label("ID_UploadFromDevice")}</ListItemText>
                <VisuallyHiddenInput
                    type="file"
                    onChange={handleUpload}
                    accept="image/*;capture=camera"
                />                
                </MenuItem>
                <MenuItem onClick={()=>{handleMenuClose(); onButtonClicked("URL")}}><ListItemIcon><LinkIcon /></ListItemIcon><ListItemText>{label("ID_DisplayURL")}</ListItemText></MenuItem>
                <MenuItem onClick={()=>{handleMenuClose(); onButtonClicked("Imagine"); }}><ListItemIcon><AutoFixHighIcon /></ListItemIcon><ListItemText>{label("ID_AIImage")}</ListItemText></MenuItem>
                <MenuItem onClick={()=>{handleMenuClose(); onButtonClicked("Clear")}}><ListItemIcon><ClearIcon /></ListItemIcon><ListItemText>{label("ID_ClearDisplay")}</ListItemText></MenuItem>
            </Menu>              
            <Stack 
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 0, sm: 1.5 }}
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
            >

            <img id="FrameImage"
                style={isPortrait ? divFramePortrait : divFrameLandscape}
            />
            
            </Stack>

            <DisplayURLDialog open={(dialogType == "URL") ? true : false} handleSubmit={handleSubmit} handleClose={handleClose} OKButtonTitle={label("ID_Generate")}/>
            <ImagineDialog open={(dialogType=="Imagine") ? true : false} handleSubmit={handleSubmit} handleClose={handleClose} OKButtonTitle={label("ID_Generate")}/>

            </>
   
        </>
            
    )
}

export default Controls;
